import React, { useState, useEffect,useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { Form, Button, Row, Col } from "react-bootstrap";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css"; 
import "./css/school-contact.css";
import "./css/dashboard.css"; 
import axiosOrganizationInstance from "./AxiosOrganizationInstance";
import {
  getStoredOrganizationId,
  getStoredUserId,
  setStoredOrganizationId,
} from "./organizationStorage";
import { UserContext } from "../context/UserContext";
import { sanitizeAadharInput, validateAadharNumber, formatAadharDisplay, formatAadharDisplayOrFallback } from "../restaurant/formatDisplay";
import { confirmAction } from "../restaurant/ui/feedback";

function OrganizationContact() {
  const {organizationName} = useContext(UserContext)
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [authToken, setAuthToken] = useState(true);
  const [organizationId, setorganizationId] = useState(null);
  const [organizationStatus, setOrganizationStatus] = useState("");
  const navigate= useNavigate()
  const [contact, setContact] = useState({
    name: "",
    email: "",
    aadharNo: "",
    contactNumber: "",
    status: "ACTIVE",
    password: "",
    organizationId:null,
    roleId:null,
    roleName:'',
    organizationName:"",
    roleName:"",
    createdById:null,
    updatedById:null,

  });

  useEffect(() => {
    const loadContacts = async () => {
      try {
        const token = localStorage.getItem("Token");
        let orgId = getStoredOrganizationId();
        const userId = getStoredUserId();

        if (!orgId && userId) {
          const linkResponse = await axiosOrganizationInstance.get(
            `/organization/user/${userId}/organization`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          orgId = String(linkResponse.data.organizationId);
          setStoredOrganizationId(orgId);
        }

        if (!orgId) {
          setorganizationId(null);
          setContacts([]);
          return;
        }

        setorganizationId(orgId);
        await fetchContacts(orgId);
        await fetchOrganizationStatus(orgId);
      } catch (error) {
        console.error("Error loading organization contacts:", error);
        setContacts([]);
      }
    };

    loadContacts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchOrganizationStatus = async (orgId) => {
    try {
      const token = localStorage.getItem("Token");
      const response = await axiosOrganizationInstance.get(`/organization/${orgId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data && response.data.status) {
        setOrganizationStatus(response.data.status);
      }
    } catch (error) {
      console.error("Error fetching organization status:", error);
    }
  };

  useEffect(() => {
      const token = localStorage.getItem("Token");
      console.log('token', token)
      setAuthToken(token);
  
      if (authToken===false) {
        navigate("/organization/signin"); // Redirect if no token is found
      }
    }, [authToken]);

  const fetchContacts = async (orgId) => {
    const resolvedOrgId = orgId || organizationId;
    if (!resolvedOrgId) {
      return;
    }

    try {
      const token = localStorage.getItem("Token");
      const response = await axiosOrganizationInstance.get(
        `/organization/${resolvedOrgId}/users`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setContacts(response.data.users || []);
    } catch (error) {
      if (error.response?.status === 704) {
        setContacts([]);
        return;
      }
      console.error("Error fetching users:", error);
      setContacts([]);
    }
  };
console.log('Contacts', contacts)

  const handleContactSubmit = async (e) => {
    e.preventDefault();

    const aadharError = validateAadharNumber(contact.aadharNo);
    if (aadharError) {
      alert(aadharError);
      return;
    }
   
    try {
      let response;
      console.log('Selected Person', selectedContact)
      if (isEditing && selectedContact) {
        const token = localStorage.getItem("Token");
        response = await axiosOrganizationInstance.put(
          `/organization/users/${selectedContact.organizationUserId}`,
          contact,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Set the token in the 'Authorization' header
            },
          }
        );
      } else {
        const token = localStorage.getItem("Token");
        const payload = {
          ...contact,
          roleId: contact.roleId ? Number(contact.roleId) : null,
          createdById: getStoredUserId(),
          updatedById: getStoredUserId(),
          organizationId: getStoredOrganizationId(),
          organizationName: localStorage.getItem("organizationName"),
        };

        response = await axiosOrganizationInstance.post(
          "/organization/users",
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Set the token in the 'Authorization' header
            },
          }
        );
      }

      if (response.status === 200 || response.status === 201) {
        const updatedContact = response.data;
        if (isEditing) {
          setContacts((prevContacts) =>
            prevContacts.map((cnt) =>
              cnt.user_id === selectedContact.user_id ? updatedContact : cnt
            )
          );
          alert("user updated successfully!");
        } else {
          setContacts((prevContacts) => [...prevContacts, updatedContact]);
          alert("Contact added successfully!");
        }
      } else {
        alert(`Failed to submit contact: ${response.statusText}`);
      }
      fetchContacts(organizationId);
    resetForm();
    } catch (error) {
      console.error("Error submitting contact:", error);
      alert(error.response?.data?.message || error.message);
    }
  };

  const handleContactChange = (e) => {
    const { name, value } = e.target;

    setContact((prevContact) => ({
      ...prevContact,
      [name]: name === 'aadharNo' ? sanitizeAadharInput(value) : value,
    }));
  };

  const handleContactType = (e)=>{
  
  const selectedValue = e.target.value;
  const selectedLabel = e.target.options[e.target.selectedIndex].text;
  // console.log('2',selectedLabel)
  // contact.roleId=selectedValue;
  // contact.roleName=selectedLabel;
  setContact((prevContact)=>({...prevContact,roleId:selectedValue,roleName:selectedLabel}))
  }

  

  const handleSelectContact = (organizationUserId) => {
    console.log('contact data',organizationUserId)
  
    const contactToEdit = contacts.find((cnt) => cnt.organizationUserId === organizationUserId);
    console.log('contact To Edit', contactToEdit)
    if (contactToEdit) {
      setContact({
        ...contactToEdit,
        aadharNo: contactToEdit.aadharNo ?? contactToEdit.aadhar_no ?? contactToEdit.aadharNumber ?? "",
      });
      
      setSelectedContact(contactToEdit);
      setIsEditing(true);
      setIsFormVisible(true);
    }
  };

  const handleDeleteContact = async (personId) => {
    console.log('Person Id',personId)
    const ok = await confirmAction({
      title: "Delete contact?",
      message: "Are you sure you want to delete this contact?",
      confirmLabel: "Delete",
      danger: true,
    });
    if (ok) {
      try {
        const token = localStorage.getItem("Token");
        await axiosOrganizationInstance.delete(`/organization/users/${personId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setContacts((prevContacts) =>
          prevContacts.map((cnt) =>
            cnt.organizationUserId === personId
              ? { ...cnt, status: "INACTIVE" }
              : cnt
          )
        );
        alert("Contact deactivated successfully!");
      } catch (error) {
        console.error("Error deleting contact:", error);
        alert("Error deleting contact. Please check the console for details.");
      }
    }
  };

  const handleAddNewContact = () => {
    resetForm();
    setIsFormVisible(true);
  };

  const resetForm = () => {
    setContact({
      name: "",
    email: "",
    aadharNo: "",
    contactNumber: "",
    status: "ACTIVE",
    password: "",
    roleId:null,
    roleName:"",
    
    });
    setIsEditing(false);
    setSelectedContact(null);
    setIsFormVisible(false);
  };

  return (
    <div className="mt-5" style={{marginLeft:'30px'}}>
      <div
        className="d-flex justify-content-between align-items-center mb-4"
        style={{ borderBottom: "1px solid #D1D1D6", paddingBottom: "10px" }}
      >
        <p style={{ fontSize: "24px", fontWeight: "700" }}>Contact Details</p>
        

        <Button
          variant="outline-dark"
          onClick={(e) => {
            e.preventDefault();
            handleAddNewContact();
          }}
          className="me-2"
          disabled={organizationStatus === "INACTIVE" || !organizationId || organizationId === "null"}
          style={{
            width: "90px",
            backgroundColor: (organizationStatus === "INACTIVE" || !organizationId || organizationId === "null") ? "#e9ecef" : "#FFFEF0",
            border: "1px solid #0976A1",
            color: (organizationStatus === "INACTIVE" || !organizationId || organizationId === "null") ? "#6c757d" : "#017EF3",
            cursor: (organizationStatus === "INACTIVE" || !organizationId || organizationId === "null") ? "not-allowed" : "pointer",
          }}
        >
          New
        </Button>
      </div>

      <Row>
        {contacts.length>0&&(
 <Col lg={12} className="mb-4">
 <div className="ag-theme-quartz organization-data-grid">
   <AgGridReact
     columnDefs={[
       {
         headerName: "Contact Name",
         field: "name",
         suppressMovable: true,
         width: "220",
       },
       {
         headerName: "Email",
         field: "email",
         suppressMovable: true,
         width: "220",
       },
       {
         headerName: "Aadhar No",
         field: "aadharNo",
         suppressMovable: true,
         width: "160",
         valueFormatter: (params) => formatAadharDisplayOrFallback(params.value, '—'),
       },
       {
         headerName: "Phone Number",
         field: "contactNumber",
         suppressMovable: true,
         width: "160",
       },
       {
         headerName: "Contact Type",
         field: "roleName",
         suppressMovable: true,
         width: "140",
       },
       {
         headerName: "Status",
         field: "status",
         suppressMovable: true,
         width: "100",
       },
       {
         headerName: "Actions",
         width: "110",
         cellRenderer: (params) => {
           return (
             isEditing === false && (
               <div
                 className="d-flex justify-content-center align-items-center"
                 style={{ marginTop: "12px" }}
               >
                 <CiEdit
                  style={{
                   fontSize: "24px",
                   color: organizationStatus === "INACTIVE" ? "#6c757d" : "#017EF3",
                   cursor: organizationStatus === "INACTIVE" ? "not-allowed" : "pointer",
                   opacity: organizationStatus === "INACTIVE" ? 0.5 : 1,
                 }}
                   onClick={() =>
                     organizationStatus !== "INACTIVE" && handleSelectContact(params.data.organizationUserId)
                   }
                 />

                 <MdOutlineDeleteOutline
                 style={{
                   marginLeft: "20px",
                   color: organizationStatus === "INACTIVE" ? "#6c757d" : "#FF3B30",
                   cursor: organizationStatus === "INACTIVE" ? "not-allowed" : "pointer",
                   fontSize: "24px",
                   opacity: organizationStatus === "INACTIVE" ? 0.5 : 1,
                 }}
                   onClick={() =>
                     organizationStatus !== "INACTIVE" && handleDeleteContact(params.data.organizationUserId)
                   }
                 />
               </div>
             )
           );
         },
         suppressMovable: true,
       },
     ]}
     rowData={contacts}
     pagination={false}
     paginationPageSize={10}
     domLayout="autoHeight"
   />
 </div>
</Col>
        )}
       

        {isFormVisible && (
          <Col lg={12} className="mb-4 organization-form-section">
            <div className="card shadow-box" style={{ border: "none" }}>
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="text-center">
                    {isEditing ? "Edit Contact" : "Add New Contact"}
                  </h5>
                </div>
                <hr />
                <Form
                  onSubmit={handleContactSubmit}
                  className="contact-form"
                  autoComplete="off"
                >
                  <input
                    type="text"
                    name="fake-username"
                    autoComplete="username"
                    tabIndex={-1}
                    aria-hidden="true"
                    style={{ position: 'absolute', left: '-9999px', width: 1, height: 1, opacity: 0 }}
                  />
                  <input
                    type="password"
                    name="fake-password"
                    autoComplete="current-password"
                    tabIndex={-1}
                    aria-hidden="true"
                    style={{ position: 'absolute', left: '-9999px', width: 1, height: 1, opacity: 0 }}
                  />
                  <Row>
                    
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Person Name
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="text"
                          name="name"
                          value={contact.name}
                          onChange={handleContactChange}
                          required
                          autoComplete="off"
                          disabled={organizationStatus === "INACTIVE"}
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Email
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="email"
                          name="email"
                          id="organization-new-contact-email"
                          value={contact.email}
                          onChange={handleContactChange}
                          required
                          autoComplete="off"
                          disabled={organizationStatus === "INACTIVE"}
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Aadhar Number
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="text"
                          name="aadharNo"
                          value={formatAadharDisplay(contact.aadharNo || "")}
                          onChange={handleContactChange}
                          required
                          maxLength={14}
                          inputMode="numeric"
                          placeholder="1111 1111 1111"
                          autoComplete="off"
                          disabled={organizationStatus === "INACTIVE"}
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Phone Number
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="tel"
                          name="contactNumber"
                          value={contact.contactNumber}
                          onChange={handleContactChange}
                          required
                          autoComplete="off"
                          disabled={organizationStatus === "INACTIVE"}
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Contact Type
                          </Form.Label>
                        </div>
                        <Form.Select
                          name="contactType"
                          value={contact.roleId}
                          onChange={handleContactType}
                          required
                          disabled={organizationStatus === "INACTIVE"}
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        >
                          <option value=''>Select Contact Type</option>
                          <option value='3'>SUPERVISOR</option>
                          <option value='6'>TEACHER</option>
                          <option value='7'>AYA</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Status
                          </Form.Label>
                        </div>
                        <Form.Control
                          as="select"
                          name="status"
                          value={contact.status}
                          onChange={handleContactChange}
                          disabled={organizationStatus === "INACTIVE"}
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        >
                          <option value="ACTIVE">Active</option>
                          <option value="INACTIVE">Inactive</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    {!isEditing && (
  <Col md={6}>
    <Form.Group className="mb-3">
      <div style={{ display: "flex", alignItems: "flex-start" }}>
        <Form.Label
          style={{
            fontSize: "14px",
            fontWeight: "700",
            lineHeight: "20px",
            color: "#323E4F",
          }}
        >
          Password
        </Form.Label>
      </div>
      <Form.Control
        type="password"
        name="password"
        id="organization-new-contact-password"
        value={contact.password}
        onChange={handleContactChange}
        autoComplete="new-password"
        disabled={organizationStatus === "INACTIVE"}
        style={{
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "20px",
          color: "#697483",
        }}
        required
      />
    </Form.Group>
  </Col>
)}

                  </Row>
                  
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      variant="outline-dark"
                      type="submit"
                      disabled={organizationStatus === "INACTIVE"}
                      style={{
                        width: "120px",
                        backgroundColor: organizationStatus === "INACTIVE" ? "#e9ecef" : "#FFFEF0",
                        border: "1px solid #0976A1",
                        color: organizationStatus === "INACTIVE" ? "#6c757d" : "#017EF3",
                        marginRight: "10px",
                        cursor: organizationStatus === "INACTIVE" ? "not-allowed" : "pointer",
                      }}
                    >
                      {isEditing ? "Save" : "Add Contact"}
                    </Button>
                    <Button
                    variant="outline-secondary"
                    onClick={resetForm}
                    disabled={organizationStatus === "INACTIVE"}
                    style={{
                      width: "120px",
                      backgroundColor: organizationStatus === "INACTIVE" ? "#e9ecef" : "#FFFEF0",
                      border: "1px solid #017EF3",
                      color: organizationStatus === "INACTIVE" ? "#6c757d" : "#017EF3",
                      cursor: organizationStatus === "INACTIVE" ? "not-allowed" : "pointer",
                    }}
                  >
                    Cancel
                  </Button>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
}

export default OrganizationContact;
